import { Logo } from "./Logo";
import { ThemeToggle } from "./ThemeToggle";
import { Button } from "@/components/ui/button";
import { MobileNav } from "./MobileNav";
import { Link } from "react-router-dom";

export function PreAuthNavbar() {
    return (
        <header className="sticky top-0 z-40 w-full border-b border-border/50 backdrop-blur-xl supports-[backdrop-filter]:bg-background/80 shadow-sm">
            <div className="mx-auto flex h-16 max-w-7xl items-center gap-4 px-4">
                <MobileNav />
                <Logo />
                <nav className="hidden md:flex items-center gap-8 text-sm font-medium ml-12">
                    <Link to="/#features" className="text-muted-foreground hover:text-foreground transition-all duration-200 hover:scale-105 cursor-pointer">Features</Link>
                    <Link to="/#pricing" className="text-muted-foreground hover:text-foreground transition-all duration-200 hover:scale-105 cursor-pointer">Pricing</Link>
                    <Link to="/#faq" className="text-muted-foreground hover:text-foreground transition-all duration-200 hover:scale-105 cursor-pointer">FAQ</Link>
                </nav>
                <div className="ml-auto flex items-center gap-4">
                    <div className="hidden sm:flex items-center gap-3">
                        <Button asChild variant="ghost" className="hidden lg:inline-flex hover:bg-accent/80 transition-all duration-200">
                            <Link to="/login">Login</Link>
                        </Button>
                        <Button asChild className="hidden lg:inline-flex shadow-md hover:shadow-lg transition-all duration-200 hover:scale-105">
                            <Link to="/register">Get Started</Link>
                        </Button>
                    </div>
                    <ThemeToggle />
                </div>
            </div>
        </header>
    );
}
